/**
 * Detects if the current environment is production
 * @returns true if running on production, false otherwise
 */
export function isProduction(): boolean {
  return (
    window.location.hostname === 'network.lts.com' ||
    window.location.hostname.includes('prod.')
  );
}
